// tslint:disable-next-line max-line-length

export const FAIRPLAY_CERTIFICATE_URL = 'https://cdn.dazn.com/config/cert/fairplay.cer';
export const CONVIVA_CUSTOMER_KEY = 'e2570d46af0ee5302e3bddf2d43804b477ae7ab0';
